import { render } from "./notFoundPage.vue?vue&type=template&id=36993e7a"
const script = {}

import "./notFoundPage.vue?vue&type=style&index=0&id=36993e7a&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__